class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.select = this.querySelector('.js-language-select');
        $(this.select).on('change', this.onChange.bind(this));
    }

    onChange() {
        this.form.submit();
    }
}

customElements.define('localization-form', LocalizationForm);
